// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo } from "react";
const InputError = ({ error }) => {
  return (
    <div className="flex text-[#ff2d2d]" role="alert">
      <div className="Roboto text-[10px] leading-none">{error}</div>
    </div>
  );
};

export default memo(InputError);
